/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="calendar">
      <path
        id="Vector"
        d="M9.25753 2.59995C9.25753 1.82558 8.64468 1.19995 7.8861 1.19995C7.12753 1.19995 6.51468 1.82558 6.51468 2.59995V3.99995H4.45753C3.32182 3.99995 2.40039 4.94058 2.40039 6.09995V9.59995H21.6004V6.09995C21.6004 4.94058 20.679 3.99995 19.5432 3.99995H17.4861V2.59995C17.4861 1.82558 16.8732 1.19995 16.1147 1.19995C15.3561 1.19995 14.7432 1.82558 14.7432 2.59995V3.99995H9.25753V2.59995Z"
        fill="#D6C7BA"
      />
      <path
        id="Vector_2"
        opacity="0.6"
        d="M2.40039 9.6001H21.6004V20.8201C21.6004 21.9132 20.679 22.8001 19.5432 22.8001H4.45753C3.32182 22.8001 2.40039 21.9132 2.40039 20.8201V9.6001Z"
        fill="#D6C7BA"
      />
    </g>
  </svg>
);

export default SvgComponent;
